import { FC } from "react"
import { useTranslation } from "react-i18next"
import { RotationRightButton } from "../buttons/iconButtons/action/RotationCollection"
import { CardsTabletButton, TabletButton, TabletEndButton } from "../buttons/iconButtons/other/PanelCollection"
import { AdditionalButton } from "../buttons/iconButtons/other/PanelCollection"
import { FilePlusButton } from "../buttons/iconButtons/other/FileAndFolderCollection"
import { EmptySquareButton } from "../buttons/iconButtons/editor/ActionCollection"
import Tooltip from "../tooltips/Tooltip"
import BaseCommandsPanel, { ICommand } from "./BaseCommandsPanel"
import { ReportActionButton } from "../../Business/Reports/Components/ReportActionButton/ReportActionButton"
import { ReportFilter } from "../../Business/Reports/Shared/ReportFilter"
import { useUserContext } from "../../system/providers/userContextProvider"
import { checkActiveCommands } from "../../Business/CommonHelperFunctions"
import { IdTableVariant } from "../../@types/enumsGlobal"
import { IKeyValuePair } from "../../Business/Reports/Shared/Interfaces/IKeyValuePair"

interface IPanelEvent {
    disabled?: boolean
    onClick: () => any
    onSubItemClick?: () => any
    filters?: Array<ReportFilter>
    value?: any
}

interface ILotsByPanelProps {
    rootTranslation: string
    lotMovement?: IPanelEvent
    add?: IPanelEvent
    editGoods?: IPanelEvent
    openLotsByLots?: IPanelEvent
    print?: IPanelEvent
    refresh?: IPanelEvent
    groupProcessing?: IPanelEvent
    permission?: IPermission
    buttonConfig?: ICommand[]
}

// Панель команд на странице товарных остатков по товарам либо по партиям 
const LotsByCommandsPanel: FC<ILotsByPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t(props.rootTranslation + 'mainPanel.' + value)
    const docT = (value: string) => t('documentsCommandsPanel.' + value)

    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);

    return (
        <>
            <BaseCommandsPanel groups={[
                [
                    {
                        iconButton: <Tooltip title={baseT('lotMovement')}>
                            <TabletButton sizeVariant="mini" {...props.lotMovement} />
                        </Tooltip>
                    },
                    {
                        iconButton: <Tooltip title={baseT('editGoods')}>
                            <CardsTabletButton sizeVariant="mini" {...{ ...props.editGoods, disabled: props.editGoods?.disabled || !activeCommands.editGoods }} />
                        </Tooltip>
                    },
                    ...(props.add ? [{
                        iconButton: <Tooltip title={'Добавить ГК'}>
                            <FilePlusButton sizeVariant="mini" {...{ ...props.add, disabled: props.add?.disabled || !activeCommands.add }} />
                        </Tooltip>
                    }] : []),
                ],
                [
                    {
                        iconButton: <Tooltip title={baseT('openRemains')}>
                            <TabletEndButton sizeVariant="mini" {...props.openLotsByLots} />
                        </Tooltip>
                    }
                ],
                [
                    {
                        iconButton: <Tooltip title={docT('printing')}>
                            <ReportActionButton
                                caption={baseT('printing')}
                                menuPlacement={"bottomLeft"}
                                iconButton={true}
                                disabled={props.print?.disabled}
                                onMenuClick={
                                    () => props.print?.onClick()
                                }
                                onMenuItemClick={() => {
                                    const result = props.print?.onSubItemClick?.()
                                    return result
                                }}
                                filters={props.print?.filters}
                            />
                        </Tooltip>
                    },
                ],
                [
                    {
                        iconButton: <Tooltip title={docT('refresh')}>
                            <RotationRightButton sizeVariant="mini" {...props.refresh} />
                        </Tooltip>
                    },
                    ...(props.buttonConfig || [])
                ],
                ...(props.groupProcessing ? [[
                    {
                        iconButton: <Tooltip title={'Групповая обработка'}>
                            {props.groupProcessing.value ? <AdditionalButton sizeVariant="mini" {...props.groupProcessing} /> : <EmptySquareButton sizeVariant="mini" {...props.groupProcessing} />}
                        </Tooltip>
                    }
                ]] : []),
            ]} />
        </>
    )
}
export default LotsByCommandsPanel